import Vue from "vue/dist/vue.js";

Vue.use(require("vue-moment"));
